import { render, staticRenderFns } from "./alarm_sound_settings.vue?vue&type=template&id=fbee4c7c"
import script from "./alarm_sound_settings.vue?vue&type=script&lang=js"
export * from "./alarm_sound_settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports